import {html, PropertyValues} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {when} from "lit/directives/when.js";
import {UuidHelper} from "../../../helpers/uuid.helper";
import {AbstractLitInputComponent} from "../../abstract-lit-input.component";
import {Entity} from "../../../domain/entities/entity";
import {ClassOf} from "../../../types/class-of.type";
import {property} from "lit/decorators/property.js";
import {container} from "tsyringe";
import {EntityManager} from "../../../persistence/entity.manager";
import {state} from "lit/decorators/state.js";
import {repeat} from "lit/directives/repeat.js";
import {styleMap} from "lit/directives/style-map.js";
import {UsedColor} from "../../../types/used-color.type";

@customElement(`ha-input-color`)
export class HaInputColorComponent extends AbstractLitInputComponent<string> {

    @property({type: Object})
    public entity: ClassOf<Entity> | null = null;

    private _id = UuidHelper.generateV7();

    @state()
    private _colors: UsedColor[] = [];

    protected willUpdate(changedProperties: PropertyValues) {
        if (changedProperties.has(`entity`) && !!this.entity) {
            container.resolve(EntityManager).getRepositoryForEntity(this.entity)!.findAllColors().then(colors => this._colors = colors);
        }
    }

    protected shouldUpdate(_changedProperties: PropertyValues): boolean {
        return !!this.value && super.shouldUpdate(_changedProperties);
    }

    protected render(): unknown {

        return html`
            ${when(this.label, () => html`
                    <label for=${this._id}>${this.label}</label>
            `)}
            <div class="wrapper">
                <input type="color"
                       id=${this._id}
                       .value=${this.value}
                       @input=${this._onInput}
                       ?disabled=${this.readonly}
                >
                <ul class="used-colors">
                    <div class="label_used-colors">Bereits genutzt:</div>
                    ${repeat(this._colors, c => c.color, usedColor => {
                        const colorStyle = {
                            "background-color": usedColor.color
                        }
                        return html`
                        <li class="used_colors__badge"
                            style=${styleMap(colorStyle)}
                            @click=${() => this._onChooseUsedColor(usedColor)}
                        >
                            ${usedColor.total}
                        </li>
                    `;
                    })}
                </ul>
            </div>             
            ${this._renderHelperText()}
            ${this._renderErrors()}
        `;
    }

    private _onInput(evt: Event): void {
        const str: string = (evt.target as HTMLInputElement).value;
        if (str === this.value) {
            return;
        }

        this.value = str;
        this.fire(this.value, 'value-changed');
    }

    private _onChooseUsedColor(usedColor: UsedColor): void {
        if (this.value === usedColor.color) {
            return;
        }

        this.value = usedColor.color;
        this.fire(this.value, 'value-changed');
    }
}
